import { Disclosure as DisclosureHeadless, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { cn } from '@workspace/utils';

export interface DisclosureProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  /** Classes du bouton (ex. couleur du titre). */
  buttonClassName?: string;
}

/**
 * Composant accordéon avec animation
 * - État ouvert/fermé avec icône rotative
 * - Couleurs custom Tailwind (primary, secondary)
 * - Animation fluide d'ouverture/fermeture
 */
export function Disclosure({ title, children, isOpen, buttonClassName }: DisclosureProps) {
  return (
    <DisclosureHeadless as="div" className="w-full border border-primary-200 rounded-xl" defaultOpen={isOpen}>
      {({ open }) => (
        <>
          <DisclosureButton
            className={cn(
              open ? 'rounded-t-lg' : 'rounded-lg',
              'flex w-full justify-between bg-primary-100 px-4 py-2 text-left text-sm font-medium text-secondary hover:bg-primary hover:text-primary-foreground focus:outline-none transition-colors',
              buttonClassName,
            )}
          >
            <span>{title}</span>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              strokeWidth={1.5} 
              stroke="currentColor" 
              className={cn(open ? 'rotate-180' : '', 'h-5 w-5 transition-transform')}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </DisclosureButton>
          <DisclosurePanel className="px-4 pb-2 pt-4 text-sm text-foreground">
            {children}
          </DisclosurePanel>
        </>
      )}
    </DisclosureHeadless>
  );
}
